import React from 'react';
import GalleryModal from '@hpstellar/pdp/GalleryModal';

import withPageComponents from '../../../../page/components/with-page-components';
import { PriceContainer } from '../../../../product/components/product-price/with-product-price';
import AddOnPrice from '../../../../product/components/product-configurations/addon-price';
import { withAddToCart } from '../../../../product/components/purchase-button-container';
import useAddToCart from '../../../../hooks/useAddToCart';

import './image-modal.less';

const EMPTY_OBJECT = {};

const mapImages = images => {
    return images.map(i => {
        return {
            url: i.xlarge || i.lrg || i.src,
            type: i.type,
        };
    });
};

const getModalData = (product, images, currentPrice) => {
    if (product) {
        const { ctaText, ctoLink, customizeText, isOOS, currency, locale } = currentPrice || {};
        const { name, isComingSoon } = product;
        const priceDifference = currentPrice.regularPrice - currentPrice.salePrice;
        const price = currentPrice
            ? {
                  currencySymbol: '$',
                  regularPrice: currentPrice.regularPrice,
                  salePrice: currentPrice.salePrice,
                  productType: product.prdClass.toLowerCase(),
                  currency,
                  locale,
                  priceDifference,
              }
            : EMPTY_OBJECT;
        return {
            data: {
                images: mapImages(images),
                ratings: {
                    score: product.rating,
                    reviewsCount: product.numReviews,
                },
                title: name,
                price,
                sku: product.sku,
                outOfStock: !isComingSoon ? isOOS : false,
            },
            cta: {
                ctaText: isComingSoon ? 'Coming soon' : ctaText,
                ctoLink,
                customizeText,
            },
        };
    }
    return EMPTY_OBJECT;
};

export default withPageComponents(
    ({ product, images, imageIndex, setImageIndex }) => {
        const { addToCart, launchCartFlyout } = useAddToCart();
        return (
            <PriceContainer products={[product]}>
                {({ prices }) => {
                    const productPrice = prices[product.sku];
                    return (
                        <AddOnPrice sku={product.sku} price={productPrice}>
                            {({ totalPrice }) => {
                                const { data, cta } = getModalData(product, images, totalPrice);
                                return (
                                    <GalleryModal
                                        className="imageModal"
                                        isOpen={imageIndex > -1}
                                        initialSlide={Math.max(imageIndex, 0)}
                                        data={data}
                                        onModalClose={() => setImageIndex(-1)}
                                        onAdd={() => {
                                            if (product.prdClass === 'CTO') {
                                                document.location.href = cta.ctoLink;
                                            } else {
                                                //TODO: temp fix to trigger xsell modal
                                                let mainBtn = document.getElementById('pdpAddToCartBtn');
                                                if (mainBtn) {
                                                    mainBtn.click();
                                                } else {
                                                    addToCart(product, 1).then(() => {
                                                        launchCartFlyout();
                                                    });
                                                }
                                            }
                                        }}
                                        addText={cta.customizeText || cta.ctaText}
                                    />
                                );
                            }}
                        </AddOnPrice>
                    );
                }}
            </PriceContainer>
        );
    },
    { components: ['product'] }
);
